import { utilHelper } from "../../_helpers";
import {NOTIFICATION_SENT} from "../../../components/i18n/i18n";

const relativeUrl = 'api/notification'

export const notificationsService = {
    search,
    saveItem,
    updateItem,
    deleteItem,
    sendAlert
};

// search
function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data:data, showAlert:false })
}

// save
function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

// update
function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data:data });
}

// delete
function deleteItem(id, fbDB) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

// send alert
function sendAlert(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/send`, 'POST', { data:data, message:NOTIFICATION_SENT });
}